import fetchIntercept from 'fetch-intercept';

export const AuthInterceptor = () => {
  fetchIntercept.register({
    request: function (url, config = {}) {
      // Ensure config exists and modify headers
      config.headers = {
        ...config.headers,
        name: 'Aravindh', // Add custom headers if needed
      };

      return [url, config];
    },

    requestError: function (error) {
      return Promise.reject(error);
    },

    response: async function (response) {

      if (response.ok) {
        return response;
      }

      switch (response.status) {
        case 400:
        case 402:
        case 404:
          console.warn("Client Error: Redirecting to Oops page.");
          window.location.href = "/Oops";
          break;
        case 500:
        case 502:
          console.error("Server Error: Redirecting to Oops page.");
          window.location.href = "/Oops";
          break;
        default:
          console.warn("Unhandled Response: Returning response.");
      }

      return response;
    },

    responseError: function (error) {
      return Promise.reject(error);
    },
  });
};
